import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
// import { fetchReceiveLineWeights, setReceiveLineWeights } from '../../actions/receive_actions';
import SetReceiveWeightModal from '../../components/Inventories/setReceiveWeightModal';

const validate = (values) => {
  const errors = {};
  if (values.importLine && !values.importLine.match(/^[0-9]*\.?[0-9]+( [0-9]*\.?[0-9]+)*$/)) {
    errors.importLine = 'Invalid input format, please separate values with a whitespace';
  }
  return errors;
};

const setReceiveWeightModal = reduxForm({
    form: 'setReceiveWeightModal',
    validate,
})(SetReceiveWeightModal);
const selector = formValueSelector('setReceiveWeightModal');

function mapStateToProps(state) {
  const totalWeight = selector(state, 'TotalWeight');
  const importLine = selector(state, 'importLine');
  return {
    totalWeight,
    importLine,

    salesOrderLineWeights: state.salesOrders.salesOrderLineWeights,
    salesOrderLineWeightsIsLoading: state.salesOrders.salesOrderLineWeightsIsLoading,
    salesOrderLineWeightsError: state.salesOrders.salesOrderLineWeightsError,

    salesOrderLineWeightsIsEditing: state.salesOrders.salesOrderLineWeightsIsEditing,
    editSalesOrderLineWeightsSuccess: state.salesOrders.editSalesOrderLineWeightsSuccess,
    editSalesOrderLineWeightsError: state.salesOrders.editSalesOrderLineWeightsError
  };
}

export default connect(mapStateToProps, { })(setReceiveWeightModal);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/setReceiveWeightModal.jsx